/* Kindly v2 PDP: gallery, bundle builder, size sheet, sticky bar, prints-showcase taps.
   State and maths live in kindly-offer.js (window.KindlyOffer), tested in v2/test/offer.test.js. */
(function () {
  'use strict';
  var HELP = {
    'S/M': 'S/M fits calves 11-15 in · women\'s shoe 5-8',
    'L/XL': 'L/XL fits calves 14-18 in · women\'s shoe 8.5-12 · men\'s 7-11',
    '2XL Wide': '2XL Wide fits calves 17-23 in · women\'s and men\'s shoe 9-13',
    '3XL Wide': '3XL Wide fits calves 22-30 in'
  };

  function readCatalog(root) {
    var el = root.querySelector('[data-kindly-catalog]');
    var data = el ? JSON.parse(el.textContent) : { prints: [], unit: 2999 };
    var bySlug = {};
    data.prints.forEach(function (p) { bySlug[p.slug] = p; });
    return { list: data.prints, bySlug: bySlug, unit: data.unit };
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function initGallery(root) {
    var track = root.querySelector('[data-kindly-gal-track]');
    if (!track) return;
    var slides = track.children, idx = root.querySelector('[data-kindly-gal-i]');
    var thumbs = root.querySelectorAll('[data-kindly-gal-go]');
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = current();
        if (idx) idx.textContent = i + 1;
        thumbs.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      }, 60);
    }, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-kindly-gal-go')); }); });
    var p = root.querySelector('[data-kindly-gal-prev]'), n = root.querySelector('[data-kindly-gal-next]');
    if (p) p.addEventListener('click', function () { go(current() - 1); });
    if (n) n.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    });
  }

  function initBuilder(root) {
    var O = window.KindlyOffer;
    var cat = readCatalog(root);
    var unit = cat.unit || +root.getAttribute('data-unit') || 2999;
    var slugs = cat.list.map(function (p) { return p.slug; });
    var state = O.createState({
      landed: root.getAttribute('data-landed'),
      slugs: slugs,
      /* data-default-tier: the preselected deal when the URL has no ?tier= (PDP 5, LP 2 = the middle tile). */
      tier: O.parseTier(location.search, +root.getAttribute('data-default-tier') || 5),
      size: root.getAttribute('data-size') || null
    });
    var cursor = 0, busy = false;
    var rowsBox = root.querySelector('[data-kindly-rows]');
    var stack = root.querySelector('[data-kindly-stack]');
    var atc = root.querySelector('[data-kindly-atc]');
    var atcLabel = root.querySelector('[data-kindly-atc-label]');
    var msg = root.querySelector('[data-kindly-msg]');
    var helper = root.querySelector('[data-kindly-size-helper]');
    var sizeSheet = root.querySelector('[data-kindly-size-sheet]');
    /* "Sold out for now · Back soon": none of the 6 prints has stock. The builder stays as a preview, the button is
       disabled, the restock email form shows, and no per-pair "pick another print" errors are shown. */
    var allOut = O.allSoldOut(cat.list);
    var restock = root.querySelector('[data-kindly-restock]');
    root.classList.toggle('is-soldout', allOut);
    if (restock) restock.hidden = !allOut;

    function name(slug) { return cat.bySlug[slug] ? cat.bySlug[slug].name : slug; }
    /* data-pair-sizes (?view=lp): every pair row also gets its own size select (default = the main size). */
    var pairSizes = root.hasAttribute('data-pair-sizes');
    var SIZES = Object.keys(HELP);
    function variantFor(slug, size) { var p = cat.bySlug[slug]; size = size || state.size; return p && size ? p.variants[size] : null; }
    function soldOut(slug, size) { if (allOut) return false; size = size || state.size; var v = variantFor(slug, size); return !!(size && (!v || !v.available)); }

    function showMsg(text) { msg.textContent = text; msg.hidden = !text; }

    function renderRows() {
      var flags = O.freeFlags(state.tier);
      rowsBox.innerHTML = '';
      state.picks.forEach(function (slug, i) {
        var row = el('div', 'kb__row');
        row.setAttribute('data-row', i);
        var head = el('p', 'kb__row-head');
        head.appendChild(el('span', 'kb__row-n', 'Pair ' + (i + 1)));
        head.appendChild(document.createTextNode(' · '));
        head.appendChild(el('span', 'kb__row-name', name(slug)));
        if (flags[i]) head.appendChild(el('span', 'kb__free', 'FREE'));
        row.appendChild(head);
        var rowSize = O.sizeOf ? O.sizeOf(state, i) : state.size;
        if (pairSizes) {
          var sel = el('select', 'kb__row-size');
          sel.setAttribute('aria-label', 'Size for pair ' + (i + 1));
          var ph = el('option', null, 'Size'); ph.value = ''; ph.disabled = true; sel.appendChild(ph);
          SIZES.forEach(function (sz) { var o = el('option', null, sz); o.value = sz; sel.appendChild(o); });
          sel.value = rowSize || '';
          sel.addEventListener('change', function () { state = O.setPairSize(state, i, sel.value); render(); });
          head.insertBefore(sel, head.querySelector('.kb__free'));
        }
        var sw = el('div', 'kb__swatches');
        sw.setAttribute('role', 'radiogroup');
        sw.setAttribute('aria-label', 'Print for pair ' + (i + 1));
        cat.list.forEach(function (p) {
          var b = el('button', 'kb__sw');
          b.type = 'button';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', p.slug === slug ? 'true' : 'false');
          var out = soldOut(p.slug, rowSize);
          if (out) b.classList.add('is-out');
          b.setAttribute('aria-label', p.name + (out ? ', sold out in ' + rowSize : ''));
          b.setAttribute('data-print', p.slug);
          var img = el('img');
          img.src = p.swatch; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy';
          b.appendChild(img);
          b.addEventListener('click', function () {
            if (out) { showMsg(p.name + ' is sold out in ' + rowSize + '. Pick another print.'); return; }
            state = O.setPick(state, i, p.slug);
            render();
          });
          sw.appendChild(b);
        });
        row.appendChild(sw);
        if (soldOut(slug, rowSize)) row.appendChild(el('p', 'kb__row-err', name(slug) + ' is sold out in ' + rowSize + '. Pick another print for this pair.'));
        rowsBox.appendChild(row);
      });
    }

    function renderStack() {
      stack.innerHTML = '';
      var flags = O.freeFlags(state.tier);
      state.picks.forEach(function (slug, i) {
        var s = el('span', 'kb__sock' + (flags[i] ? ' is-free' : ''));
        var p = cat.bySlug[slug];
        if (p) s.style.backgroundImage = 'url("' + p.swatch + '")';
        s.title = 'Pair ' + (i + 1) + ': ' + name(slug) + (flags[i] ? ' (free)' : '');
        stack.appendChild(s);
      });
      var mixed = O.sizeOf && state.picks.some(function (s, i) { return O.sizeOf(state, i) !== state.size; });
      var capSize = mixed ? 'mixed sizes' : state.size;
      var cap = el('span', 'kb__stack-cap', state.tier + (state.tier === 1 ? ' pair' : ' pairs') + (capSize ? ' · ' + capSize : ''));
      stack.appendChild(cap);
    }

    function renderPrice() {
      var info = O.tierInfo(state.tier, unit);
      var pl = root.querySelector('[data-kindly-priceline]');
      pl.querySelector('[data-kindly-compare]').textContent = info.compareText;
      pl.querySelector('[data-kindly-compare]').hidden = !info.compareText;
      pl.querySelector('[data-kindly-pay]').textContent = info.payText;
      pl.querySelector('[data-kindly-per]').textContent = state.tier === 1 ? 'for 1 pair' : 'for ' + info.pairs + ' pairs · ' + info.perPairText;
      atcLabel.textContent = info.atcLabel;
      var sl = root.querySelector('[data-kindly-sticky-label]');
      if (sl) sl.textContent = info.stickyLabel;
      var si = root.querySelector('[data-kindly-sticky-img]');
      if (si && cat.bySlug[state.picks[0]]) si.src = cat.bySlug[state.picks[0]].swatch;
      root.querySelectorAll('.kb__tier input').forEach(function (r) { r.checked = +r.value === state.tier; });
      root.querySelectorAll('.kb__tier').forEach(function (l) { l.classList.toggle('is-on', +l.getAttribute('data-tier') === state.tier); });
    }

    function renderSize() {
      root.querySelectorAll('.kb__pill').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-size') === state.size ? 'true' : 'false'); });
      helper.textContent = state.size ? HELP[state.size] : 'Pick your size. Go by your calf first.';
      helper.classList.toggle('is-empty', !state.size);
    }

    function render() {
      renderPrice(); renderSize(); renderRows(); renderStack();
      if (allOut) {
        atc.disabled = true;
        atcLabel.textContent = O.SOLDOUT.atc;
        var sl = root.querySelector('[data-kindly-sticky-label]');
        if (sl) sl.textContent = O.SOLDOUT.sticky;
        var sb = root.querySelector('[data-kindly-sticky-btn]');
        if (sb) sb.textContent = O.SOLDOUT.stickyBtn;
        showMsg('');
        return;
      }
      var check = O.itemsPayload(state, cat.bySlug);
      var blocked = check.problems.some(function (p) { return p.type === 'soldout' || p.type === 'missing'; });
      atc.disabled = blocked || busy;
      if (!blocked) showMsg('');
    }

    root.querySelectorAll('.kb__tier input').forEach(function (r) {
      r.addEventListener('change', function () { state = O.setTier(state, +r.value); cursor = 0; render(); });
    });
    root.querySelectorAll('.kb__pill').forEach(function (b) {
      b.addEventListener('click', function () { state = O.setSize(state, b.getAttribute('data-size')); render(); });
    });
    root.querySelector('[data-kindly-same]').addEventListener('click', function () { state = O.sameForAll(state); render(); });

    /* Prints showcase (another section on the page): tap = set the next pair, scroll back up. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-kindly-showcase]');
      if (!t) return;
      e.preventDefault();
      var r = O.setNextPick(state, t.getAttribute('data-kindly-showcase'), cursor);
      state = r.state; cursor = r.next;
      render();
      var row = rowsBox.querySelector('[data-row="' + r.index + '"]');
      (row || rowsBox).scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (row) { row.classList.add('is-flash'); setTimeout(function () { row.classList.remove('is-flash'); }, 1600); }
    });

    /* On a product page, "?tier=" links (guarantee block, etc.) open the builder on THIS page instead of
       leaving for another print, so the landed print and the picks are kept. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="tier="]');
      if (!a || root.contains(a) && a.closest('.kb')) return;
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
      if (u.pathname.indexOf('/products/') !== 0) return;
      e.preventDefault();
      state = O.setTier(state, O.parseTier(u.search, state.tier)); render();
      root.querySelector('.kb').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    function openSize() {
      if (sizeSheet && sizeSheet.showModal) sizeSheet.showModal();
      else {
        var acc = root.querySelector('[data-kindly-acc="size"]');
        if (acc) { acc.open = true; acc.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    }
    root.querySelectorAll('[data-kindly-open-size]').forEach(function (b) { b.addEventListener('click', openSize); });
    document.querySelectorAll('a[href="#size"], a[href="#find-my-size"]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openSize(); });
    });
    if (sizeSheet) {
      sizeSheet.querySelector('[data-kindly-close-size]').addEventListener('click', function () { sizeSheet.close(); });
      sizeSheet.addEventListener('click', function (e) { if (e.target === sizeSheet) sizeSheet.close(); });
    }

    atc.addEventListener('click', function () {
      if (allOut) return;
      var check = O.itemsPayload(state, cat.bySlug);
      if (!check.ok) {
        if (check.problems.some(function (p) { return p.type === 'size'; })) {
          showMsg('Pick your size first. Not sure? Tap "Find my size".');
          root.querySelector('.kb__size').scrollIntoView({ behavior: 'smooth', block: 'center' });
          root.querySelector('.kb__pill').focus({ preventScroll: true });
        } else showMsg('One of your prints is sold out in that size. Pick another print or size for that pair.');
        return;
      }
      busy = true; atc.disabled = true; atc.classList.add('is-busy');
      var drawer = document.querySelector('cart-drawer');
      var body = { items: check.items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) { showMsg(res.j.description || res.j.message || 'Something went wrong. Please try again.'); return; }
          if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ id: null, sections: res.j.sections });
          } else {
            location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { showMsg('Something went wrong. Please check your connection and try again.'); })
        .finally(function () { busy = false; atc.classList.remove('is-busy'); render(); });
    });

    /* Sticky bar: shows once the add-to-cart button has scrolled above the screen. Checked on every scroll frame
       (an IntersectionObserver misses a fast fling or jump that skips straight past the button). */
    var sticky = root.querySelector('[data-kindly-sticky]');
    if (sticky) {
      var stickyOn = null, raf = 0;
      var updateSticky = function () {
        raf = 0;
        var show = atc.getBoundingClientRect().bottom < 0;
        if (show === stickyOn) return;
        stickyOn = show;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      };
      var queueSticky = function () { if (!raf) raf = (window.requestAnimationFrame || setTimeout)(updateSticky); };
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky);
      updateSticky();
      sticky.querySelector('[data-kindly-sticky-btn]').addEventListener('click', function () {
        if (allOut && restock) {
          restock.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var em = restock.querySelector('[data-kindly-restock-email]');
          if (em) em.focus({ preventScroll: true });
          return;
        }
        root.querySelector('.kb').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    render();
  }

  function run() {
    document.querySelectorAll('[data-kindly-pdp]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      initGallery(root);
      if (window.KindlyOffer) initBuilder(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
